export default __webpack_public_path__ + "static/media/procu.dcd2663f.webp";